import styled from 'styled-components';

export const CardsWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 72px;
    padding: 32px 0;
`;
export const CardTitle = styled('div')`
    color: #435970;
    font-size: 14px;
    font-weight: bold;
`;
export const IconsWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 7%;
`;
export const Card = styled('div')`
    border: 1px solid transparent;
    padding: 16px 16px;
    border-radius: 4px;
    background: #f8fafc;
`;
export const CardHeader = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    &.web {
        cursor: pointer;
    }
`;
export const OpenedSection = styled('div')`
    width: 100%;
    min-height: 100px;
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
`;
export const LeftColumn = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`;
export const RightColumn = styled('div')`
    width: 100%;
`;
export const Title = styled('div')`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #40596f;
    margin-bottom: 12px;
`;
export const DescWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    padding-bottom: 10px;
    &.bullet {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 2px;
        padding-bottom: 4px;
    }
    .sub {
        font-size: 13px;
        font-weight: bold;
        color: #40596f;
    }
    .desc {
        font-size: 13px;
        line-height: 18px;
        color: #40596f;
    }
`;
